<template>
    <div class="section text-center" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>

    <div class="section sneha-page-content" v-else>
        <router-link
            v-if="isUnitLevel"
            :to="applicationsListPath"
            class="sneha-program-item sneha-program-item--applications"
        >
            <span class="sneha-program-title mal-text">സമർപ്പിച്ച അപേക്ഷകൾ</span>
            <ion-icon name="chevron-forward-outline" class="sneha-program-chevron"></ion-icon>
        </router-link>

        <p v-if="programs.length" class="sneha-page-note mal-text">പദ്ധതി തിരഞ്ഞെടുത്ത് അപേക്ഷ സമർപ്പിക്കുക.</p>

        <div v-if="programs.length" class="sneha-program-list">
            <router-link
                v-for="(program, index) in programs"
                :key="program.id"
                :to="programIntroPath(program.id)"
                class="sneha-program-item"
                :class="programColorClass(index)"
            >
                <span class="sneha-program-title mal-text">
                    {{ program.button_label || program.title }}
                </span>
                <ion-icon name="chevron-forward-outline" class="sneha-program-chevron"></ion-icon>
            </router-link>
        </div>

        <p v-else class="text-center text-muted mal-text sneha-empty-note">പദ്ധതികൾ ലഭ്യമല്ല.</p>
    </div>
</template>

<script>
import UserService from "@/services/user.service";

const PROGRAM_COLORS = [
    "sneha-program-item--blue",
    "sneha-program-item--teal",
    "sneha-program-item--amber",
    "sneha-program-item--violet",
];

export default {
    name: "SnehaSparsham",
    data() {
        return {
            loading: true,
            programs: [],
        };
    },
    computed: {
        isUnitLevel() {
            return parseInt(this.$route.params.sub_level, 10) === 4;
        },
        applicationsListPath() {
            return `/org/${this.$route.params.sub_level}/${this.$route.params.id}/sneha-sparsham-applications`;
        },
    },
    mounted() {
        this.$root.updateParent("സ്നേഹ സ്പർശം");
        this.loadPrograms();
    },
    methods: {
        programIntroPath(programId) {
            return `/org/${this.$route.params.sub_level}/${this.$route.params.id}/sneha-sparsham/${programId}/intro`;
        },
        programColorClass(index) {
            return PROGRAM_COLORS[index % PROGRAM_COLORS.length];
        },
        loadPrograms() {
            this.loading = true;
            UserService.authPostRequest("get-sneha-sparsham-programs", {}).then((res) => {
                this.loading = false;
                if (res.data.status === "success") {
                    this.programs = res.data.data.programs || [];
                }
            }).catch(() => {
                this.loading = false;
                this.programs = [];
            });
        },
    },
};
</script>

<style scoped>
.sneha-page-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 8px;
}

.sneha-page-note {
    margin: 4px 0 2px;
    padding: 0 2px;
    font-size: 0.9rem;
    color: #6c757d;
    line-height: 1.45;
}

.sneha-empty-note {
    margin: 8px 0 0;
}

.sneha-program-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sneha-program-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-height: 52px;
    padding: 14px 16px;
    text-decoration: none;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    transition: opacity 0.15s ease, transform 0.15s ease;
}

.sneha-program-item:active {
    opacity: 0.92;
    transform: scale(0.99);
}

.sneha-program-title {
    flex: 1;
    min-width: 0;
    font-size: 0.95rem;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.4;
    word-break: break-word;
    text-align: left;
}

.sneha-program-chevron {
    flex-shrink: 0;
    font-size: 22px;
    color: rgba(255, 255, 255, 0.9);
}

.sneha-program-item--blue {
    background: linear-gradient(135deg, #1a418c 0%, #2563eb 100%);
    border: 1px solid #1a418c;
}

.sneha-program-item--teal {
    background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
    border: 1px solid #0f766e;
}

.sneha-program-item--amber {
    background: linear-gradient(135deg, #b45309 0%, #d97706 100%);
    border: 1px solid #b45309;
}

.sneha-program-item--violet {
    background: linear-gradient(135deg, #6d28d9 0%, #8b5cf6 100%);
    border: 1px solid #6d28d9;
}

.sneha-program-item--applications {
    background: linear-gradient(135deg, #475569 0%, #64748b 100%);
    border: 1px solid #475569;
}
</style>
